import {CommonModule} from '@angular/common';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {
  ConfiguratorEndpointInterceptor,
  CpsCampaignTrackingInterceptor,
  DCPConfiguratorCartService,
  DCPConfiguratorRouterExtractorService,
  DcpConfiguratorCommonsService,
} from '@dcp/configurator';
import {RefQuoteIdConfiguratorInterceptor} from '@app/services/reference-quote/ref-quote-id-configurator.interceptor';
import {AuthGuard, ConfigModule, I18nModule, OccConfig} from '@spartacus/core';
import {ConfiguratorRouterExtractorService} from '@spartacus/product-configurator/common';
import {ConfiguratorCartService, ConfiguratorCommonsService} from '@spartacus/product-configurator/rulebased';
import {CmsPageGuard} from '@spartacus/storefront';
import {CartEditModule} from '@app/cart/edit-cart/cart-edit.module';

import {ConfiguratorComponentsModule} from './configurator-components/configurator-components.module';
import {ConfiguratorComponent} from './configurator.component';

import {ConfigureUrlErrorComponent} from './error-handling/configure-url-error/configure-url-error.component';

import {DefaultConfiguratorErrorComponent} from './error-handling/default-configurator-error/default-configurator-error.component';

@NgModule({
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductConfiguratorComponent: {
          component: ConfiguratorComponent,
          guards: [AuthGuard],
        },
      },
    }),
    ConfigModule.withConfig({
      backend: {
        occ: {
          endpoints: {
            createVariantConfiguration:
              'products/${productCode}/configurators/ccpconfigurator?provideAllAttributes=true',
          },
        },
      },
    } as OccConfig),
    ConfiguratorComponentsModule,
    CartEditModule,
    I18nModule,
    RouterModule.forChild([
      {
        data: {
          cxRoute: 'configuratorError',
        },
        path: 'configurator/error/:errorCode',
        component: ConfigureUrlErrorComponent,
        canActivate: [AuthGuard, CmsPageGuard],
      },
      {
        data: {
          cxRoute: 'configuratorErrorDefault',
        },
        path: 'configurator/error',
        component: DefaultConfiguratorErrorComponent,
        canActivate: [AuthGuard, CmsPageGuard],
      },
    ]),
    ConfiguratorComponent,
  ],
  exports: [ConfiguratorComponent, RouterModule],
  providers: [
    {
      provide: ConfiguratorCartService,
      useClass: DCPConfiguratorCartService,
    },
    {
      provide: ConfiguratorRouterExtractorService,
      useClass: DCPConfiguratorRouterExtractorService,
    },
    {
      provide: ConfiguratorCommonsService,
      useClass: DcpConfiguratorCommonsService,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ConfiguratorEndpointInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CpsCampaignTrackingInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RefQuoteIdConfiguratorInterceptor,
      multi: true,
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ConfiguratorModule {}
